<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/admin"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button size="large" (click)="AddNew()"
        ><ion-icon
          slot="icon-only"
          name="add-outline"
          style="font-size: 38px"
        ></ion-icon
      ></ion-button>
    </ion-buttons>
    <ion-title>Articles</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div
    class="ion-text-center ion-padding"
    *ngIf="!isLoading && loadedArticles.length===0"
  >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img
            src="../../../assets/images/MimboLogo.png"
            class="logo"
          ></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-text color="darkmimbo"
      >You have not added any articles yet. <br />
    </ion-text>
  </div>

  <ion-grid *ngIf="!isLoading && loadedArticles.length>0">
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-list color="lightmimbo">
          <div *ngFor="let article of loadedArticles">
            <ion-item-sliding color="lightmimbo">
              <ion-item
                detail
                button="true"
                color="lightmimbo"
                style="padding-top: 4px; padding-bottom: 4px"
                (click)="ViewArticle(article.id)"
              >
                <img [src]="article.image" class="avatar" />
                <div style="padding-bottom: 12px; padding-top: 12px">
                  <h1>{{article.title}}</h1>
                  <h6 [innerHTML]="article.content"></h6>
                </div>
              </ion-item>
              <ion-item-options>
                <ion-item-option
                  color="danger"
                  (click)="deleteArticle(article.id)"
                  ><ion-icon name="trash-outline" slot="start"></ion-icon
                  >Delete</ion-item-option
                >
              </ion-item-options>
            </ion-item-sliding>
          </div>
        </ion-list></ion-col
      ></ion-row
    ></ion-grid
  >
</ion-content>

<ion-modal class="full-ion-modal" [isOpen]="isModalOpen" #newArticleModal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()"
            ><ion-icon name="arrow-back-outline" slot="icon-only"> </ion-icon
          ></ion-button>
        </ion-buttons>
        <ion-title>Add/Update Article</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content
      class="ion-padding"
      color="lightmimbo"
      *ngIf="isPreviewMode == false"
    >
      <form #f="ngForm" class="ion-padding" (ngSubmit)="previewArticle()">
        <ion-grid>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input
                  label="Title"
                  required
                  [(ngModel)]="selectedTitle"
                  name="titleCtrl"
                  labelPlacement="floating"
                  placeholder="Enter Article Title"
                ></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-input
                  required
                  label="Added By"
                  name="addedByCtrl"
                  [(ngModel)]="selectedAddedBy"
                  labelPlacement="floating"
                  placeholder="Enter Added By"
                ></ion-input>
              </ion-item> </ion-col
          ></ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-textarea
                  rows="20"
                  name="contentCtrl"
                  autoGrow="true"
                  required
                  label="Article Content"
                  labelPlacement="floating"
                  [(ngModel)]="selectedContent"
                  placeholder="Enter Article Content..."
                >
                </ion-textarea>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="!isUpdate">
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="mimbolight">
                <ion-checkbox
                  name="notifCtrl"
                  #chkNotif
                  [(ngModel)]="sendNotif"
                >
                  Send Notification
                </ion-checkbox>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
              <ion-item color="lightmimbo">
                <div>
                  <app-image-picker
                    (photoCaptured)="onPhotoCaptured($event)"
                  ></app-image-picker>
                  <br />
                  <small>
                    <ion-text
                      color="success"
                      style="display: block"
                      *ngIf="uploadedImage.length>0"
                      >Image Uploaded Successfully</ion-text
                    >
                    <ion-text
                      color="danger"
                      style="display: block"
                      *ngIf="showImageError && uploadedImage.length==0"
                      >You need to upload an image to continue</ion-text
                    >
                  </small>
                </div>
              </ion-item>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col
              sizeMd="10"
              offsetMd="1"
              sizeXl="6"
              offsetXl="3"
              class="ion-text-center"
            >
              <ion-button type="submit" [disabled]="!f.valid"
                ><ion-icon name="eye-outline" slot="start"></ion-icon>
                Preview Article
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </ion-content>
    <ion-content *ngIf="isPreviewMode == true" color="lightmimbo">
      <ion-grid>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-item color="lightmimbo" *ngIf="!isUpdate">
              <ion-text *ngIf="sendNotif" color="success" class="notif-label"
                ><ion-icon name="checkmark-outline"></ion-icon>A NOTIFICATION
                WILL BE SENT</ion-text
              >
              <ion-text *ngIf="!sendNotif" color="danger" class="notif-label">
                <ion-icon name="close-outline"></ion-icon>A NOTIFICATION WILL
                NOT BE SENT</ion-text
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-item color="lightmimbo">
              <img [src]="uploadedImage" class="avatar" />
              <div style="padding-bottom: 12px; padding-top: 12px">
                <h1>{{selectedTitle}}</h1>
                <h6 [innerHTML]="selectedContent.substring(0,200) + '...'"></h6>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-item color="lightmimbo">
              <div class="prewrap" [innerHTML]="selectedContent"></div>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            sizeMd="10"
            offsetMd="1"
            sizeXl="6"
            offsetXl="3"
            class="ion-text-center"
          >
            <ion-button (click)="AddArticle()" *ngIf="!isUpdate"
              ><ion-icon name="save-outline" slot="start"></ion-icon>Add
              Article</ion-button
            >
            <ion-button (click)="UpdateArticle()" *ngIf="isUpdate"
              ><ion-icon name="save-outline" slot="start"></ion-icon>Update
              Article</ion-button
            >
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ng-template>
</ion-modal>
